import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { HttpLogEntry } from '../../entities/httpLogEntry/httpLogEntry';
import * as fromGraphQl from './graphql';

export class HttpLogsDataSource extends NXDataSourcePrime<HttpLogEntry> {
  constructor(apollo: Apollo,
    @Inject('env') environment: any
    ) {
    super(apollo, fromGraphQl.HTTP_LOGS_QUERY, environment);
  }
  public selectedHttpLogEntry: HttpLogEntry;
  handleSubscriptionResult(data: fromGraphQl.HttpLogsQueryResponse): void {
    super.setSubject(
      data?.httpLogs?.content ? data?.httpLogs?.content : [],
      data?.httpLogs?.totalElements ? data?.httpLogs.totalElements : 0
    );
    if (data?.httpLogs?.totalElements > 0) {
      if(!this.selectedHttpLogEntry) {
        this.selectedHttpLogEntry = data?.httpLogs?.content[0];
      }
    }
    else {
      this.selectedHttpLogEntry = null;
    }
    this.querySubscription?.unsubscribe();
  }

  loadHttpLogs(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
